<template>
  <div id="menu" class="overflowAuto" hidden>
    <div class="container">
      <div class="row no-gutters">
        <div class="col-6 col-sm-6 col-lg-4 col-md-4 col-xl-3 menu-item">
          <a href="/dialer" @click="abrirTelaOperador">
            <div
              class="menu-background menu-dialer"
              data-popover="true"
              data-placement="bottom"
              data-trigger="hover"
              title="Tela do Operador"
              data-content="Acesse a central operacional do sistema, efetue discagens automaticamente conforme programado por Campanhas, Agendamentos ou atue na área Receptiva."
            >
              <i class="fas fa-phone-square icon"></i>
              <br />Tela do Operador
            </div>
          </a>
        </div>
        <div class="col-6 col-sm-6 col-lg-4 col-md-4 col-xl-3 menu-item">
          <a href="/dashboard">
            <div
              class="menu-background menu-dashboard"
              data-popover="true"
              data-placement="bottom"
              data-trigger="hover"
              title="Dashboard"
              data-content="Acompanhe em tempo real status de operadores, dados de seu faturamento e chamadas."
            >
              <i class="fas fa-chart-pie icon"></i>
              <br />Dashboard
            </div>
          </a>
        </div>
        <div class="col-6 col-sm-6 col-lg-4 col-md-4 col-xl-3 menu-item">
          <a href="/realtime">
            <div
              class="menu-background menu-realtime"
              data-popover="true"
              data-placement="bottom"
              data-trigger="hover"
              title="Realtime"
              data-content="Monitore e gerencie em tempo real sua equipe de telemarketing."
            >
              <i class="fas fa-clock icon"></i>
              <br />Realtime
            </div>
          </a>
        </div>
        <div class="col-6 col-sm-6 col-lg-4 col-md-4 col-xl-3 menu-item">
          <a href="/ranking">
            <div
              class="menu-background menu-ranking"
              data-popover="true"
              data-placement="bottom"
              data-trigger="hover"
              title="Ranking"
              data-content="Seus operadores agrupados de acordo com metas de faturamento e chamadas."
            >
              <i class="fas fa-list-ol icon"></i>
              <br />Ranking de Metas
            </div>
          </a>
        </div>
        <div class="col-6 col-sm-6 col-lg-4 col-md-4 col-xl-3 menu-item">
          <a href="/customer_base">
            <div
              class="menu-background menu-customer_base"
              data-popover="true"
              data-placement="bottom"
              data-trigger="hover"
              title="Carteira de Clientes"
              data-content="Confira sua carteira de clientes filtrando por operador e cliente."
            >
              <i class="fas fa-list-ol icon"></i>
              <br />Carteira de Clientes
            </div>
          </a>
        </div>
        <div class="col-6 col-sm-6 col-lg-4 col-md-4 col-xl-3 menu-item">
          <a href="/campaign">
            <div
              class="menu-background menu-campaign"
              data-popover="true"
              data-placement="bottom"
              data-trigger="hover"
              title="Campanhas"
              data-content="Crie e monitore campanhas de discagem automática."
            >
              <i class="fas fa-bullhorn icon"></i>
              <br />Campanhas
            </div>
          </a>
        </div>
        <div class="col-6 col-sm-6 col-lg-4 col-md-4 col-xl-3 menu-item">
          <a href="/schedule">
            <div
              class="menu-background menu-schedule"
              data-popover="true"
              data-placement="bottom"
              data-trigger="hover"
              title="Agendamento de Ligações"
              data-content="Agende ligações para um operador específico."
            >
              <i class="fas fa-calendar-check icon"></i>
              <br />Agendamento de Ligações
            </div>
          </a>
        </div>
        <div class="col-6 col-sm-6 col-lg-4 col-md-4 col-xl-3 menu-item">
          <a href="/callback">
            <div
              class="menu-background menu-callback"
              data-popover="true"
              data-placement="bottom"
              data-trigger="hover"
              title="Callback"
              data-content="Confira ligações abandonadas, não atendidas ou deixadas na caixa postal e agende um retorno."
            >
              <i class="fas fa-reply icon"></i>
              <br />Callback
            </div>
          </a>
        </div>
        <div class="col-6 col-sm-6 col-lg-4 col-md-4 col-xl-3 menu-item">
          <a href="/records">
            <div
              class="menu-background menu-records"
              data-popover="true"
              data-placement="bottom"
              data-trigger="hover"
              title="Gravações"
              data-content="Ouça todas as chamadas de entrada e saída, contando com filtros para uma busca específica."
            >
              <i class="fas fa-voicemail icon"></i>
              <br />Gravações
            </div>
          </a>
        </div>
        <div class="col-6 col-sm-6 col-lg-4 col-md-4 col-xl-3 menu-item">
          <a href="/reports">
            <div
              class="menu-background menu-reports"
              data-popover="true"
              data-placement="bottom"
              data-trigger="hover"
              title="Relatórios"
              data-content="Otimize suas decisões com o auxílio de relatórios de faturamento, operadores e chamadas."
            >
              <i class="fas fa-signal icon"></i>
              <br />Relatórios
            </div>
          </a>
        </div>
        <div class="col-6 col-sm-6 col-lg-4 col-md-4 col-xl-3 menu-item">
          <a href="/script">
            <div
              class="menu-background menu-script"
              data-popover="true"
              data-placement="bottom"
              data-trigger="hover"
              title="Script"
              data-content="Coloque scripts de atendimento que irão facilitar o procedimento de atendimento dos seus operadores."
            >
              <i class="fas fa-scroll icon"></i>
              <br />Script
            </div>
          </a>
        </div>
        <div class="col-6 col-sm-6 col-lg-4 col-md-4 col-xl-3 menu-item">
          <a href="/employees">
            <div
              class="menu-background menu-employees"
              data-popover="true"
              data-placement="bottom"
              data-trigger="hover"
              title="Controle de Colaborador"
              data-content="Controle de colaborador"
            >
              <i class="fas fa-users icon"></i>
              <br />Controle de Colaborador
            </div>
          </a>
        </div>
        <div class="col-6 col-sm-6 col-lg-4 col-md-4 col-xl-3 menu-item">
          <a href="/ura">
            <div
              class="menu-background menu-ura"
              data-popover="true"
              data-placement="bottom"
              data-trigger="hover"
              title="Configurações da URA"
              data-content="Configurações da URA"
            >
              <i class="fas fa-wrench icon"></i>
              <br />Configurações da URA
            </div>
          </a>
        </div>
        <div class="col-6 col-sm-6 col-lg-4 col-md-4 col-xl-3 menu-item">
          <a href="/release">
            <div
              class="menu-background menu-release"
              data-popover="true"
              data-placement="bottom"
              data-trigger="hover"
              title="Comunicados"
              data-content="Visualize e crie novos comunicados."
            >
              <i class="fas fa-bell icon"></i>
              <br />Comunicados
            </div>
          </a>
        </div>
        <div class="col-6 col-sm-6 col-lg-4 col-md-4 col-xl-3 menu-item">
          <a href="/occurrence">
            <div
              class="menu-background menu-occurrence"
              data-popover="true"
              data-placement="bottom"
              data-trigger="hover"
              title="Ocorrência"
              data-content="Visualize e crie novas ocorrências internas."
            >
              <i class="fas fa-exclamation-triangle icon"></i>
              <br />Ocorrências
            </div>
          </a>
        </div>
        <div class="col-6 col-sm-6 col-lg-4 col-md-4 col-xl-3 menu-item">
          <a href="/marketing">
            <div
              class="menu-background menu-marketing"
              data-popover="true"
              data-placement="bottom"
              data-trigger="hover"
              title="Mensagem Marketing"
              data-content="Crie campanhas de mensagens massivas por meio de SMS, EMAIL e MENSAGEM FONADA."
            >
              <i class="fas fa-comment icon"></i>
              <br />Mensagem Marketing
            </div>
          </a>
        </div>
        <div class="col-6 col-sm-6 col-lg-4 col-md-4 col-xl-3 menu-item">
          <a href="/user">
            <div
              class="menu-background menu-user"
              data-popover="true"
              data-placement="bottom"
              data-trigger="hover"
              title="Usuário"
              data-content="Crie e gerencie os usuários do sistema."
            >
              <i class="fas fa-users-cog icon"></i>
              <br />Usuário
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        mounted() {
            //SO SEGUE LOGADA A ABA QUE ACABOU DE AUTENTICAR (VER window.loginRecente NO layout.blade.php)
            const loginRecente = window.loginRecente === true;
            const abaAutenticada = sessionStorage.getItem('aba_autenticada') === 'true';

            if (loginRecente) {
                sessionStorage.setItem('aba_autenticada', 'true');
            } else if (!abaAutenticada) {
                window.location.replace('/exit');
                return;
            }

            setTimeout(() => {
                this.cancelarLogoutPage();
            }, 700);

            this.permissions();
            var url = window.location.href;
            url = url.split('/');
            if ((url[3] == '') || (url[4] == '')) {
                $("#menu").attr("hidden", false);
                $("#menuButton").attr("hidden", true);
            }

        },
        methods: {
            //DESFAZ O LOGOUT_PAGE GRAVADO AO SAIR DA TELA DO OPERADOR PARA OUTRA PAGINA DO SISTEMA
            cancelarLogoutPage: function() {
                if (sessionStorage.getItem('operador_logado') !== 'true') {
                    return;
                }

                axios.post('/dialer/cancel-page-logout', {
                    extension_line: user.getExtension()
                }).catch(() => {});
            },

            //MARCA QUE A SAIDA DA HOME E UMA NAVEGACAO INTERNA, NAO O FECHAMENTO DA ABA
            abrirTelaOperador: function() {
                sessionStorage.setItem('abrindo_tela_operador', 'true');
            },

            permissions: function() {
                axios.get('/permission')
                    .then(response => {
                        $(response.data.allowed).each(function(index, item) {
                            $(`.menu-${item}`).css('background', `linear-gradient(rgba(4, 85, 142, 0.3), rgba(4, 85, 142, 0.5)), url('/imgs/menu/${item}-bkg.png')`);
                        })
                        $(response.data.denied).each(function(index, item) {
                            $(`.menu-${item}`).css('background', `linear-gradient(rgba(13, 14, 15, 0.9), rgba(13, 14, 15, 0.9)), url('/imgs/menu/${item}-bkg.png')`);
                            $(`.menu-${item} .icon`).removeClass().addClass('fas fa-lock icon');
                        })

                    }).catch(error => {
                        console.error(error)
                    })
            }
        }
    };
</script>